import React from 'react'

interface OTPInputProps {
  value: string
  isActive: boolean
  index: number
}

export const OTPInput: React.FC<OTPInputProps> = ({ value, isActive }) => {
  // Display-only component - all input handling is done by the hidden input in container

  const getInputStyles = () => {
    if (isActive) {
      return 'border-black border-[1.5px] text-[#232323]'
    }
    if (value) {
      return 'border-[#EBF2F2] text-[#232323]'
    }
    return 'border-[#EBF2F2] text-[#232323]'
  }

  return (
    <div className='relative z-0'>
      {!value && <OTPCircle fill={isActive ? '#1470CC' : '#D1D5DB'} />}
      <div
        className={`w-[44px] h-[48px] text-center font-[400] border rounded-[12px] 
            transition-all duration-200 bg-transparent flex items-center justify-center
            ${getInputStyles()}`}
        style={{ zIndex: 0 }}
      >
        {value}
      </div>
    </div>
  )
}

const OTPCircle = ({ fill = '#D1D5DB' }: { fill?: string }) => {
  return (
    <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 -z-10'>
      <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='4' cy='4' r='3' fill={fill} />
      </svg>
    </div>
  )
}
